import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-talk-show',
  templateUrl: './talk-show.component.html',
  styleUrls: ['./talk-show.component.css']
})
export class TalkShowComponent implements OnInit {
  videoId: string = "S6bkx2kG5dk";

  constructor() { }

  ngOnInit(): void {
  }

}
